import { z } from 'zod';
import { BaseAddressDTOSchema } from "./addresses.dto.js";
// API layer DTOs (if needed for direct address deletion endpoints)
export const SoftDeleteAddressRequestDTOSchema = z.object({
    params: z.object({
        addressId: BaseAddressDTOSchema.shape.id,
    }),
});
//# sourceMappingURL=soft-delete-address.dto.js.map